import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { DotIndicator } from '@/components/uiKit/DotIndicator';
import { useQueryNavigation } from '@/hooks';
import { FILTER_PARAMS } from '@/types/shared/navigation-tabs.enums';
import { Popover, PopoverContent, PopoverTrigger, PopoverPortal } from '@radix-ui/react-popover';
import React, { MouseEventHandler } from 'react';
import { useNavigate } from 'react-router-dom';

interface ExceedingComponentsPopoverProps {
  items: any[];
  asset_id: string;
}
export const ExceedingComponentsPopover = ({ items, asset_id }: ExceedingComponentsPopoverProps) => {
  const navigate = useNavigate();
  const { navigateWithQuery } = useQueryNavigation();
  return (
    <Popover>
      <PopoverTrigger onClick={(e) => e.stopPropagation()}>
        <Badge
          className={`bg-${items[0].health_status} text-white py-1 px-2.5 font-semibold text-xs`}
          data-testid="plus_faulty_components"
        >
          +{items.length}
        </Badge>
      </PopoverTrigger>
      <PopoverPortal>
        <PopoverContent
          side="bottom"
          align="start"
          sideOffset={4}
          className="bg-white rounded-xl flex flex-col justify-start border border-gray-300 shadow-lg z-50 w-auto min-w-[150px]"
        >
          {items.map((el, index) => (
            <div
              key={el.component_id + el.component_name}
              onClick={(e: any) => {
                e.stopPropagation();
                // const params = new URLSearchParams();
                // params.append(FILTER_PARAMS.SELECTED_COMPONENT, el.component_id);
                navigateWithQuery(`${asset_id}/components`, {
                  addParams: { [FILTER_PARAMS.SELECTED_COMPONENT]: el.component_id },
                });
              }}
              className={cn(
                `flex gap-2 items-center justify-start pl-4 pr-6 py-1.5 hover:cursor-pointer hover:bg-gray-100`,
                `${index === 0 ? 'rounded-t-xl' : ''}`,
                `${index === items.length - 1 ? 'rounded-b-xl' : ''}`
              )}
            >
              <DotIndicator status={el.health_status as 'critical'} />
              <div className="font-normal">{el.component_ui_name}</div>
            </div>
          ))}
        </PopoverContent>
      </PopoverPortal>
    </Popover>
  );
};
